<template>
  <div>
    <graph-skeleton :height="355" class="mx-3" v-if="report.length === 0"></graph-skeleton>
    <div v-else id="reportChart">
      <highcharts :options="options" ref="highcharts"></highcharts>
    </div>
  </div>
</template>

<script>
import { getPrettyStatName, formatStat, getFormattedDate } from '@/reports/components/ReportUtils'
import { getTooltipHTML, getStyledGraphOptions } from '@/reports/components/graphs/ReportGraphUtils'

export default {
  props: {

  },
  data () {
    return {
      report: [
              { session_depth: '49.0', avg_user_value: '1.0' },
        { session_depth: '38.0', avg_user_value: '2.0' },
        { session_depth: '15.0', avg_user_value: '3.0' },
        { session_depth: '11.0', avg_user_value: '4.1' },

        { session_depth: '8.0', avg_user_value: '5.0' },
      ]
    }
  },
  computed: {
    series () {
      let series = []
      for (let row of this.report) {
        let seriesRow = {}
        seriesRow.x = Number(row.avg_user_value)
        seriesRow.y = Number(row.session_depth)
        series.push(seriesRow)
      }
      return series
    },
    options () {
      let self = this
      let options = {
        chart: {
          backgroundColor: 'white',
          type: 'spline',
          height: 300,
          style: {
            fontFamily: 'Gilroy, Helvetica, sans-serif'
          },
        },
        plotOptions: {
          spline: {
            marker: {
              enabled: false,
              lineColor: null,
              symbol: 'circle',
              radius: 3
            },
            states: {
              hover: {
                enabled: false
              }
            }
          },
        },
        title: {
          text: '',
        },
        xAxis: {
          title: false,
          labels: {
            format: '${value:.2f}',
          }
        },
        yAxis: {
          title: false,
        },
        legend: {
          enabled: false
        },
        series: [{
          data: this.series,
          color: {
            linearGradient: { x1: 0, y1: 0.5, x2: 1, y2: 0.5 },
            stops: [
              [0, '#FFA263'],
              [0.25, '#FAC267'],
              [0.5, 'yellow'],
              [0.75, '#93E3A3'],
              [1, '#79E5B3']
            ]
          }
        }],
        tooltip: {
          useHTML: true,
          borderColor: '#1C1D29',
          backgroundColor: '#1C1D29',
          borderRadius: 5,
          followPointer: false,
          formatter: function () {
            let title = 'Session Depth: ' + this.point.y
            return getTooltipHTML(title, [
              { name: 'User Value', color: '#FFF', value: this.point.x},
            ])
          }
        },
      }
      return _.merge(options, getStyledGraphOptions())
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/reports/components/graphs/SessionValueSplineGraph.vue